import GloballySelected from "~/state/modules/globallySelected";
import SingleSelectedProperty from "~/state/modules/singleSelectedProperty";
import ProcessFlow from "~/models/processFlows/processFlow";
import User from "~/models/user";
import ProcessFlowStep from "~/models/processFlows/processFlowStep";
import SingleSelectedDecorator from '~/state/modules/singleSelectedDecorator';
import BaseModel from '~/models/baseModel';
import OnFlowError from '~/models/processFlows/onFlowError';

export default class Selected extends GloballySelected {
  static currentUser = new SingleSelectedProperty('currentUser', () => User);
  static processFlow = new SingleSelectedProperty("processFlow", () => ProcessFlow);
  static step = new SingleSelectedProperty("step", () => ProcessFlowStep, (step: ProcessFlowStep) => {
    if (step !== null) {
      Selected.onFlowError.deselect();
    }
  });
  static onFlowError = new SingleSelectedDecorator('onFlowError', () => OnFlowError, (onFlowError: OnFlowError) => {
    if (onFlowError !== null) {
      Selected.step.deselect();
    }
  });
}